import Checkbox from './Checkbox'
import Select from './Select'
import '../../css/controls/inputs.css'

export { Checkbox, Select }



// WEBPACK FOOTER //
// ./src/controls/inputs/index.js